import Vue from 'vue'
import Vuetify, {VApp} from 'vuetify/lib'
import '../stylus/main.styl'

Vue.use(Vuetify, {
    components:{
        VApp
    },

    theme: {
        primary: '#f2f2f2', // #E53935
        secondary: '#6ba348', // #FFCDD2 #4b4b4b
        accent: '#414142' // #3F51B5
      },
    
    iconfont: 'md',
})
